export default __webpack_public_path__ + "static/media/pic7.5b2dfd02.jpg";